<!-- 倒计时 -->
<template>
  <div class="countdown">
    <div class="count-text" v-if="countdownText && textShow">
      {{ countdownText }}
    </div>
    <div
      class="count-time"
      :class="{ 'count-time-type3': type === 3 }"
      v-html="content"
    ></div>
  </div>
</template>
<script>
export default {
  data: function () {
    return {
      content: "", //<span>03</span>天<span>03</span>小时<span>03</span>分<span>03</span>秒
      timer: null,
      textShow: true,
    };
  },
  name: "CountDown",
  props: {
    endTime: {
      type: Number,
      default: 0,
    }, //结束时间-10位时间戳
    countdownText: {
      type: String,
      default: "",
    }, //倒计时前文案
    endText: {
      type: String,
      default: "已结束",
    },
    type: {
      type: Number,
      default: 1,
    }, //1: 00天00时00分00秒  2：00：00：00
    item: {
      type: Object,
      default() {
        return {};
      },
    },
    callback: {
      type: Function,
      default() {
        return function () {};
      },
    },
  },
  mounted() {
    this.startInterval(this.endTime, this.type);
  },
  methods: {
    countDown(timestamp, type = 1) {
      if (!timestamp || timestamp < 1) return;
      const nowTime = new Date();
      const endTime = new Date(timestamp * 1000);
      const t = endTime.getTime() - nowTime.getTime();
      if (t > 0) {
        const day = Math.floor(t / 86400000);
        let hour = Math.floor((t / 3600000) % 24);
        let min = Math.floor((t / 60000) % 60);
        let sec = Math.floor((t / 1000) % 60);
        hour = hour < 10 ? "0" + hour : hour;
        min = min < 10 ? "0" + min : min;
        sec = sec < 10 ? "0" + sec : sec;
        // const dayHour = Math.floor(t / 86400000) * 24 + Math.floor((t / 3600000) % 24);
        let format = "";
        if (day > 0) {
          if (type === 1) {
            format = `<span>${day}</span>天<span>${hour}</span>小时<span>${min}</span>分<span>${sec}</span>秒`;
          } else if (type === 2) {
            format = `${day}天${hour}:${min}:${sec}`;
          } else {
            format = `<span>${
              day * 24 + hour
            }</span><i>:</i><span>${min}</span><i>:</i><span>${sec}</span>`;
          }
        }
        if (day <= 0 && hour > 0) {
          if (type === 1) {
            format = `<span>${hour}</span>小时<span>${min}</span>分<span>${sec}</span>秒`;
          } else if (type === 2) {
            format = `${hour}:${min}:${sec}`;
          } else {
            format = `<span>${hour}</span><i>:</i><span>${min}</span><i>:</i><span>${sec}</span>`;
          }
        }
        if (day <= 0 && hour <= 0) {
          if (type === 1) {
            format = `<span>${min}</span>分<span>${sec}</span>秒`;
          } else if (type === 2) {
            format = `${min}:${sec}`;
          } else {
            format = `<span>${min}</span><i>:</i><span>${sec}</span>`;
          }
        }
        this.content = format;
      } else {
        this.stopInterval();
      }
    },
    stopInterval() {
      this.textShow = false;
      clearInterval(this.timer);
      this.content = this.endText;
      this._callback();
    },
    startInterval(timestamp, type) {
      this.countDown(timestamp, type);
      this.timer = setInterval(() => {
        this.countDown(timestamp, type);
      }, 1000);
    },
    _callback() {
      if (this.callback && this.callback instanceof Function) {
        this.callback(this.item);
      }
    },
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
};
</script>
<style lang="scss">
.countdown {
  display: flex;
  align-items: center;
  .count-time {
    span {
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ef4d3c;
      line-height: 18px;
      margin: 0 2px 0 8px;
    }
  }
  .count-time-type3 {
    display: flex;
    align-items: center;
    span {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 16px;
      height: 16px;
      font-weight: 500;
      font-size: 10px;
      color: #ff4067;
      background: rgba($color: #ffccdb, $alpha: 0.7);
      border-radius: 4px;
      margin: 0;
    }
    i {
      font-style: normal;
      color: #ff4067;
      font-weight: 500;
      font-size: 10px;
      padding: 0 6px;
    }
  }
}
</style>
